import NextOfKinForm from './NextOfKin';
export default NextOfKinForm;
